import React, { useEffect, useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { qcProof, qcProofPost } from "../lib/api";

export const QcProofPanel = ({ onPosted }) => {
  const [p, setP] = useState(null), [busy, setBusy] = useState(false);
  useEffect(() => { qcProof().then(setP).catch(() => toast.error("Gate proof unavailable")); }, []);
  const post = async () => {
    setBusy(true);
    try { await qcProofPost(); toast.success("Proof posted to Anne"); onPosted?.(); } catch { toast.error("Could not post proof"); } finally { setBusy(false); }
  };
  if (!p) return <p className="mx-3 mt-2 text-xs text-cyan-100/50 flex items-center gap-2" data-testid="qc-proof-loading"><Loader2 className="w-3 h-3 animate-spin" /> Reading live source…</p>;
  return (
    <div className="mx-3 mt-2 rounded-xl border border-[#2CF6B3]/40 bg-[#2CF6B3]/5 p-3 max-h-[55vh] overflow-y-auto shrink-0" data-testid="qc-proof-panel">
      <div className="flex flex-wrap items-center gap-1.5 mb-2">
        <span className="nx-mono text-[9px] tracking-widest text-[#2CF6B3] mr-1">LIVE IN RUNNING SERVER · {String(p.checked_at).slice(11, 19)}Z</span>
        {Object.entries(p.active).map(([g, on]) => (
          <span key={g} data-testid={`qc-proof-${g}`} className={`px-2 py-0.5 rounded-full nx-mono text-[10px] font-bold ${on ? "bg-[#2CF6B3] text-[#030712]" : "bg-[#FF3D68] text-white"}`}>{g} {on ? "LIVE" : "MISSING"}</span>))}
        <button onClick={post} disabled={busy} data-testid="qc-proof-post" className="ml-auto px-3 py-1 rounded-full border border-[#2CF6B3]/60 text-[#2CF6B3] nx-mono text-[10px] tracking-widest flex items-center gap-1 hover:bg-[#2CF6B3]/10 transition-colors">
          <Send className="w-3 h-3" /> POST TO ANNE</button>
      </div>
      <p className="nx-mono text-[10px] text-cyan-100/60 mb-2" data-testid="qc-proof-fired">Fired 7d: {Object.entries(p.fired_7d).map(([k, v]) => `${k} ${v}`).join(" · ")} · tide now {p.tide_now || "—"}</p>
      {p.hooks.map((h, i) => (
        <div key={i} className="mb-2" data-testid={`qc-proof-hook-${i}`}>
          <p className="nx-mono text-[10px] text-amber-300"><b>{h.gate}</b> · {h.label} · {h.file}:{h.line} · {h.function}</p>
          <pre className="mt-1 p-2 rounded bg-[#030712] border border-white/10 text-[10px] leading-snug text-cyan-50 overflow-x-auto whitespace-pre">{h.code}</pre>
        </div>))}
    </div>
  );
};
